import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target", "rel", "aria-label"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["aria-label"]

import { computed, inject, onMounted, onUpdated, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import WebAd from '@/models/entities/web-ad';
import { configurationKey } from '@/injections';
import useElementSize from '@/composables/useElementSize';

const WEB_AD_FIXED_WIDTH_STYLE_NAME = '--web-ad-fixed-width';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCWebAdModern',
  props: {
    webAd: {}
  },
  setup(__props: any) {

const regexUrlBeginsWithSlashSlashWithOptionalProtocol = /^(?:[a-z+]+:)?\/\//i;

const props = __props;

const { t } = useI18n();
const config = inject(configurationKey);
const { addClientWidthToStyles } = useElementSize();

const hasImg = computed(() => !!props.webAd.image);
const imageSrc = computed(() => (hasImg.value ? `${config.cdn}/api/img/${props.webAd.image}` : ''));
const webAdLink = computed(() => props.webAd.link);
const webAdLinkIsRelativeUrl = computed<boolean>(() => webAdLink.value?.includes(config.siteUrl));
const isExternalLink = computed<boolean>(
  () =>
    !webAdLinkIsRelativeUrl.value &&
    regexUrlBeginsWithSlashSlashWithOptionalProtocol.test(webAdLink.value),
);

const handleResize = () => addClientWidthToStyles(WEB_AD_FIXED_WIDTH_STYLE_NAME);

onMounted(() => {
  addClientWidthToStyles(WEB_AD_FIXED_WIDTH_STYLE_NAME);
  window.addEventListener('resize', handleResize);
});

onUpdated(() => {
  addClientWidthToStyles(WEB_AD_FIXED_WIDTH_STYLE_NAME);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (webAdLink.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: webAdLink.value,
        target: isExternalLink.value ? '_blank' : '',
        rel: isExternalLink.value ? 'noopener noreferrer' : '',
        "aria-label": _ctx.webAd.label
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "wc-web-ad wc-web-ad--fixed-size wc-webad-gradient" }, null, -1)),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("div", {
          class: "wc-web-ad wc-web-ad--fixed-size position-relative user-select-none shadow-sm",
          style: _normalizeStyle({
        'background-image': `url('${imageSrc.value}')`,
      })
        }, null, 4),
        _cache[2] || (_cache[2] = _createTextVNode()),
        (!hasImg.value)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              class: "wc-web-ad__fallback-img position-absolute text-muted font-size-5xl ml-n4 mt-n4",
              icon: "camera",
              title: _unref(t)('noProductImageAvailable')
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "wc-web-ad wc-web-ad--fixed-size wc-webad-gradient" }, null, -1)),
        _cache[4] || (_cache[4] = _createTextVNode()),
        _createElementVNode("button", {
          class: "wc-web-ad wc-web-ad--fixed-size btn position-relative user-select-none shadow-sm",
          style: _normalizeStyle({
        'background-image': `url('${imageSrc.value}')`,
      }),
          "aria-label": _ctx.webAd.label
        }, [
          (!hasImg.value)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                class: "wc-web-ad__fallback-img position-absolute text-muted font-size-5xl ml-n4 mt-n4",
                icon: "camera",
                title: _unref(t)('noProductImageAvailable')
              }, null, 8, ["title"]))
            : _createCommentVNode("", true)
        ], 12, _hoisted_3)
      ]))
}
}

})